import React from "react";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import PropTypes from "prop-types";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withUserData from "../../../../../hocs/withUserData";
import accessLevelsMap from "../../../../../lib/access/accessLevelsMap";
import NoPermissionModal from "../../../pages/Plans/components/NoPermissionModal";

const RequirePlanPermission = ({
  permissions,
  children,
  hasPermission,
  userAccessLevel,
  locale,
  history
}) => {
  if (userAccessLevel === accessLevelsMap.NOT_LOGGED_IN) {
    return (
      <Redirect
        to={UrlProvider.getUrl("fe.loginWithRedirect", {
          locale,
          redirectUrl: window.location.pathname
        })}
      />
    );
  }

  if (!hasPermission(permissions)) {
    return (
      <NoPermissionModal
        permissions={permissions}
        onClose={() => {
          history.push(UrlProvider.getUrl("fe.home", { locale }));
        }}
      />
    );
  }

  return children;
};

RequirePlanPermission.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired
};

export default compose(withUserData, withRouter)(RequirePlanPermission);
